/**
 * Object.assign
 * Does not support Symbols
 */
if (typeof Object.assign !== 'function') {
  Object.assign = (target) => {
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    const targetObject = Object(target);

    for (let index = 1; index < arguments.length; index += 1) {
      const source = arguments[index];
      if (source != null) {
        Object.keys(arguments[index]).forEach((key) => {
          targetObject[key] = source[key];
        });
      }
    }

    return targetObject;
  };
}



// WEBPACK FOOTER //
// ./assets/js/polyfills/Object.js